<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formPurchaseOrderFirst">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                (onClick)="deletePurchaseOrder()">
              </app-custom-button>

              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewPurchaseOrder()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="purchaseOrderModel.userNameCreate"
                [createDate]="purchaseOrderModel.createDate" [userNameUpdate]="purchaseOrderModel.userNameUpdate"
                [updateDate]="purchaseOrderModel.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div>
            <div class="row d-flex justify-content-between">
              <div class="col-lg-8">
                <div class="row">
                  <div class="custom-container col-lg-4 col-md-4 col-sm-6 col-12">
                    <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                      [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)">
                    </app-custom-select>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-6">
                    <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                      [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-6">
                    <app-custom-input-number formControlName="alterNumber"
                      [labelText]="'Número Alt.'"></app-custom-input-number>
                  </div>
                  <div class="custom-container col-lg-4 col-md-4 col-sm-6 col-12">
                    <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                      [required]="true" (onChangeSelect)="getEnterprise($event)"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-6">
                    <app-custom-datepicker formControlName="datePurchaseOrder" [labelText]="'Fecha'"
                      [required]="true"></app-custom-datepicker>
                  </div>
                  <div class="custom-container col-lg-4 col-md-6 col-sm-8 col-12">
                    <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'"
                      [list]="listProviders" [required]="true" (onChangeSelect)="getProvider($event)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-4 col-6">
                    <app-custom-select formControlName="wayToPay" [labelText]="'Forma de Pago'" [list]="listWayToPays"
                      [required]="true"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-4 col-6">
                    <app-custom-input-text formControlName="referenceDocument" [labelText]="'Docum.Referencia'"
                      [maxLength]="10"></app-custom-input-text>
                  </div>
                  <div class="custom-container col-lg-2 col-md-5 col-sm-8 col-12">
                    <app-custom-input-text formControlName="address" [labelText]="'Dirección Entrega'" [required]="true"
                      [maxLength]="100"></app-custom-input-text>
                  </div>

                </div>
              </div>
              <div class="col-lg-4 ps-lg-3">
                <div class="row">
                  <div class="custom-container col-lg-5 col-md-3 col-sm-4 col-6">
                    <app-custom-tag [label]="'Estado'" [severity]="severityState"
                      [value]="purchaseOrderStateString"></app-custom-tag>
                  </div>
                  <div class="col-lg-7 col-md-2 col-sm-5 col-4 d-flex align-items-end">
                    <div class="mb-1">
                      <div class="d-flex gap-1">
                        <app-custom-button [icon]="'pi pi-lock'" [severity]="'primary'" (onClick)="closePurchaseOrder()"
                          [title]="purchaseOrderModel.purchaseOrderState == 1 ? 'Cierre Inicial' : 'Cierre Final'"
                          [disabled]="disableClose">
                        </app-custom-button>
                        <app-custom-button [title]="'Reversar Estado'" [icon]="'pi pi-lock-open'" [severity]="'success'"
                          (onClick)="reverseStatePurchaseOrder()" [disabled]="disableReverseState">
                        </app-custom-button>
                        <app-custom-button [title]="'Anular Orden'" [icon]="'pi pi-ban'" [severity]="'danger'"
                          (onClick)="annulPurchaseOrder()" [disabled]="disableAnnul">
                        </app-custom-button>
                      </div>
                    </div>
                  </div>
                  <div class="custom-container col-lg-12 col-md-7 col-sm-12 col-12">
                    <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                      [maxLength]="250"></app-custom-textarea>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-1">
                    <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                      (onClick)="send()" [disabled]="disableAnnul">
                    </app-custom-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style my-2 ">
          <app-purchase-order-detail [disableDetail]="disableDetail" [purchaseOrderModel]="purchaseOrderModel"
            [quantityDetails]="quantityDetails" [disableActions]="disableActions"
            (updateHeader)="getPurchaseOrderById()">
          </app-purchase-order-detail>
        </div>
        <!-- Valores e impuestos de la factura -->
        <form class="needs-validation container-style" [formGroup]="formPurchaseOrderFooter">
          <div class="col-lg-12 col-12">
            <div class="row justify-content-end m-1">
              <div class="custom-container col-lg-2 col-md-4 col-sm-4 col-6">
                <app-custom-input-decimal formControlName="subtotalValue"
                  [labelText]="'Subtotal'"></app-custom-input-decimal>
              </div>
              <div class="custom-container col-lg-2 col-md-4 col-sm-4 col-6">
                <app-custom-input-decimal formControlName="ivaValue" [labelText]="'Vr.Iva'"></app-custom-input-decimal>
              </div>
              <div class="custom-container col-lg-2 col-md-4 col-sm-4 col-6">
                <app-custom-input-decimal formControlName="totalValue" [labelText]="'Total'"></app-custom-input-decimal>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- Imprimir -->
<app-print-purchase-order id="print-purchase-order" [companyId]="companyId" [formatModel]="formatModel"
  [purchaseOrderPrint]="purchaseOrderPrint" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-purchase-order>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>